import {createUrl} from "./base-url";

export const ReportUrls = {
  getUserEventReport: (baseUrl: string) => createUrl(baseUrl, 'report/getUserEventReport'),
  exportUserEventReport: (baseUrl: string) => createUrl(baseUrl, 'report/exportUserEventReport'),
  sendEmailForReport: (baseUrl: string) => createUrl(baseUrl, 'report/sendEmailForReport')
}
